import { Props } from "../../../types";
import { html } from "lit-html";

export const cardHeader = (props: Props) => {
    const { children, className, style } = props;
    return html`<header class=${className || ""} style=${style || ""}> ${children} </header>`;
}